<template>
  <div>
    <div class="top">
      <div class="plan" @click="cancel">广告计划</div>
      <div>></div>
      <div class="new">新建广告创意</div>
    </div>
    <div class="create-plan">
      <el-form ref="form" :model="form" :rules="rules" label-width="140px">
        <el-form-item label="上传图片">
          <el-upload action="" ref="upload" class="avatar-uploader" :show-file-list="false" :on-change="logoUpload">
            <img v-if="form.video_path" :src="getImage(form.video_path)" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="所属计划" prop="plan_id">
          <el-select v-model="form.plan_id" placeholder="请选择计划" style="width: 350px;">
            <el-option :label="item.title" :value="item.plan_id" v-for="(item, index) in planLists" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属单元" prop="group_id">
          <el-select v-model="form.group_id" placeholder="请选择推广组名称" style="width: 350px;">
            <el-option :label="item.group_name" :value="item.group_id" v-for="(item, index) in groupLists" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="创意名称" prop="adv_name">
          <el-input v-model="form.adv_name" placeholder="创意名称" style="width: 350px;"></el-input>
        </el-form-item> -->
        <el-form-item label="创意标题" prop="adv_title">
          <el-input v-model="form.adv_title" placeholder="创意标题" style="width: 350px;"></el-input>
        </el-form-item>
        <el-form-item label="落地页地址" prop="url">
          <el-input v-model="form.url" placeholder="落地页地址" style="width: 350px;"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" v-model="form.remark" style="width: 350px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('form', 'advCancel')">确 定</el-button>
          <el-button @click="cancel">取 消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'createAdv',
  props: ['adv_data'],
  data() {
    return {
      form: {
        adv_id: '',
        plan_id: '',
        group_id: '',
        adv_title: '',
        url: '',
        suffix: '',
        video_path: ''
      },
      type: 'add',
      rules: {
        plan_id: [
          { required: true, message: '请选择计划', trigger: 'change' }
        ],
        group_id: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        adv_title: [
          { required: true, message: '请输入创意标题', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请输入访问url', trigger: 'blur' }
        ]
      },
      planLists: [],
      groupLists: []
    };
  },
  created() {
    if (this.adv_data.adv_id !== undefined && parseInt(this.adv_data.adv_id) > 0) {
      this.form = {
        adv_id: this.adv_data.adv_id,
        plan_id: this.adv_data.plan_id,
        group_id: this.adv_data.group_id,
        adv_title: this.adv_data.adv_title,
        url: this.adv_data.url,
        suffix: '',
        video_path: this.adv_data.video_path,
        remark: this.adv_data.remark
      };
      this.type = 'edit';
    }
    this.$http.post('/trader/index/group_form').then(res => {
      if (res.code === 200) {
        this.planLists = res.data.plan_lists;
      }
    });
    this.$function.hiddenLoading();
  },
  methods: {
    getGroupLists(plan_id) {
      return new Promise((resolve, reject) => {
        try {
          this.$http.post('/trader/index/getGroupForPlanId', {
            plan_id
          }).then(res => {
            resolve(res);
          });
        } catch (e) {
          reject({ code: 500, msg: '未知错误' });
        }
      });
    },
    submitForm(formName, make) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.video_path === '') {
            this.$message.error('请上传图片');
            return false;
          }
          const url = this.type === 'add' ? '/trader/index/createAdv' : '/trader/index/saveAdv';
          this.$http.post(url, this.form).then(res => {
            if (res.code === 200) {
              this.$message.success('操作成功');
              this.$emit('plan_call_back', make);
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancel() {
      this.$emit('plan_call_back', 'advCancel');
    },
    logoUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB');
        return;
      }
      if (file.raw.type.includes('gif')) {
        this.$message.error('图片格式不能是GIF');
        return;
      }

      this.$function.blobToDataURL(file.raw, res => {
        const imgType = file.raw.type.split('/');
        this.form.suffix = imgType[1];
        this.form.video_path = res;
      });
    },
    getImage(logo) {
      return logo.includes('base64,') ? logo : this.$Config.apiUrl + logo;
    }
  },
  watch: {
    'form.plan_id'(newVal, oldVal) {
      this.getGroupLists(newVal).then(res => {
        if (res.code === 200) {
          this.groupLists = res.data.group_lists;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped="">
  .create-plan {
    background: #fff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow-y: auto;
    border-radius: 4px;
    padding: 30px 20px 20px;
  }
  .top {
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    height: 64px;
    font-size: 14px;
    color: #606266;
    background: #fff;
    padding: 0 25px;
    div {
      margin-right: 5px;
    }
    .plan:hover {
      cursor: pointer;
      color: #1890FF;
    }
  }
  .avatar-uploader {
    width: 135px;
    display: inline-block;
    .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .el-upload:hover {
      border-color: #409EFF;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    min-width: 128px;
    height: 128px;
    line-height: 128px;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  .avatar {
    min-width: 128px;
    height: 128px;
    display: block;
  }
</style>
